import React from "react";
import { useParams } from "react-router-dom";
import { useGetTaskQuery } from "../../features/task/taskApi";
import EditForm from "./EditForm";

export default function EditTask() {
  // get params id
  const { id } = useParams();
  // get task
  const { data: task, isLoading, isError } = useGetTaskQuery(id);

  let content;
  if (isLoading) {
    content = <div>Loading...</div>;
  } else if (isError) {
    content = <div>Error</div>;
  } else {
    content = <EditForm task={task} />;
  }

  return (
    <div className="container relative">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
          Edit Task
        </h1>

        <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
          {content}
        </div>
      </main>
    </div>
  );
}
